import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "../models/RhColors.ts";

export default class SoundALongMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void {
        this.markWidth = 10;
        this.markHeight = 10;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const divisorW = 5;
        const divisorH = 2.9;
        const graphicsH = 30;
        const graphicsW = this.markWidth-this.padding*2;
        const markXOffset: number = 0;
        const markYOffset: number = -22;

        let mark = new Container();

        const arc = new Graphics();
        arc.moveTo(this.padding, graphicsH);
        arc.bezierCurveTo(graphicsW/divisorW, -(this.markHeight/divisorH), graphicsW-(graphicsW/divisorW), -(this.markHeight/divisorH), graphicsW, graphicsH);
        arc.stroke({width:this.strokeThickness, color:color, cap:"round"});
        arc.y += graphicsH;
        mark.addChild(arc);

        const st = 3;
        const mw = 17;
        const line = new Graphics();
        line.moveTo(markXOffset, markYOffset + st / 2);
        line.lineTo(markXOffset + mw, markYOffset + st / 2);
        line.stroke({width:st, color:color, cap:"round"});
        mark.addChild(line);

        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 40,
            fill: color,
            align: 'center'
        });
        const letter = new Text({text:"a", style:style});
        letter.x = (graphicsW / 2) - (letter.width / 2);
        letter.y = -(letter.height / 4);
        mark.addChild(letter);
        line.x = letter.x+3;
        line.y = (letter.y+letter.height)-12;

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}